"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ObservedDiv, Scroller } from "./scroller.js";
const StepsContext = React.createContext({
    selectedIndex: 0,
    selectIndex: () => { },
});
export function SelectionProvider({ children, rootMargin, ...rest }) {
    const [selectedIndex, selectIndex] = React.useState(0);
    return (_jsx("div", { "data-selected-index": selectedIndex, ...rest, children: _jsx(Scroller, { onIndexChange: selectIndex, rootMargin: rootMargin, children: _jsx(StepsContext.Provider, { value: {
                    selectedIndex,
                    selectIndex,
                }, children: children }) }) }));
}
export function Selectable({ index, selectOn = ["click"], ...rest }) {
    const { selectedIndex, selectIndex } = React.useContext(StepsContext);
    const eventHandlers = React.useMemo(() => {
        const handlers = {};
        if (selectOn.includes("click")) {
            handlers.onClick = () => selectIndex(index);
        }
        if (selectOn.includes("hover")) {
            handlers.onMouseEnter = () => selectIndex(index);
        }
        return handlers;
    }, [index, selectIndex, selectOn]);
    const props = {
        "data-selected": selectedIndex === index,
        ...eventHandlers,
        ...rest,
    };
    return selectOn.includes("scroll") ? (_jsx(ObservedDiv, { index: index, ...props })) : (_jsx("div", { ...props }));
}
export function Selection({ from }) {
    const { selectedIndex } = React.useContext(StepsContext);
    return from[selectedIndex];
}
export function useSelectedIndex() {
    const { selectedIndex, selectIndex } = React.useContext(StepsContext);
    return [selectedIndex, selectIndex];
}
